module.exports = __webpack_public_path__ + "e732944060004de76276f19d62de3181.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/200.png
// module id = 1773
// module chunks = 2